import { render, staticRenderFns } from "./LoaderWrapper.vue?vue&type=template&id=7d2d84d2&scoped=true&lang=pug"
import script from "./LoaderWrapper.vue?vue&type=script&lang=js"
export * from "./LoaderWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d2d84d2",
  null
  
)

export default component.exports